import script from "./GetAccessToken.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetAccessToken.vue?vue&type=script&setup=true&lang=ts"

import "./GetAccessToken.vue?vue&type=style&index=0&id=0f3c389c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3c389c"]])

export default __exports__